import { X } from 'lucide-react';
import ListeReponsesEleves from './ListeReponsesEleves';

/**
 * Bottom-sheet « Réponses — Question N » ouverte par un tap sur le compteur
 * X/Y pendant le scan : détail par élève en direct, sur le téléphone du prof
 * uniquement (rien au projo).
 */
const ReponsesSheet = ({ open, onClose, numeroQuestion, assignations, reponses }) => {
  if (!open) return null;

  return (
    <div className="absolute inset-x-0 bottom-0 z-[20] flex flex-col rounded-t-3xl overflow-hidden" style={{ background: '#151a21', maxHeight: '75%' }}>
      <div className="flex items-center justify-between px-5 pt-4 pb-3 flex-shrink-0">
        <h3 className="text-white font-bold text-[15px]">
          Réponses · Question {numeroQuestion}
          <span className="ml-2 text-[12px] font-semibold" style={{ color: 'rgba(255,255,255,.5)' }}>
            {reponses.length}/{assignations.length}
          </span>
        </h3>
        <button
          type="button"
          onClick={onClose}
          aria-label="Fermer le détail des réponses"
          className="w-9 h-9 rounded-full flex items-center justify-center text-white"
          style={{ background: 'rgba(255,255,255,.1)' }}
        >
          <X size={16} />
        </button>
      </div>
      <div className="overflow-y-auto px-5 pb-6">
        <ListeReponsesEleves assignations={assignations} reponses={reponses} />
      </div>
    </div>
  );
};

export default ReponsesSheet;
